module.exports = __webpack_public_path__ + "static/media/mine-banner-02.fa588ea3.png";